import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { FIELD_TYPES } from '../../../constants';
import { PhoneInputFieldWUT } from '../../../ui/phone-input-field';
export const BookingsPhoneWUT = props => {
  const fieldType = FIELD_TYPES.BOOKINGS_PHONE;
  return /*#__PURE__*/React.createElement(PhoneInputFieldWUT, _extends({}, props, {
    fieldType: fieldType
  }));
};
//# sourceMappingURL=bookings-phone-wut.js.map